import Helpers from '../../../common/helpers/Helpers';
import Constants from '../../../common/constants/Constants';

export const getRoles = () => {
  return Helpers.get(Constants.ROLES_URL);
};

export const getPermissions = () => {
  return Helpers.get(Constants.PERMISSIONS_URL);
};

export const getRolesPermissions = () => {
  return Helpers.get(Constants.ROLEPERMISSIONS_URL);
};

export const setPermission = (permissionId, roleId) => {
  return Helpers.put(`${Constants.ROLEPERMISSIONS_URL}/set/${permissionId}/${roleId}`);
};